import { ReactNode } from 'react';
import { Box } from '@mui/material';

interface FrameProps {
  width: number;
  children: ReactNode;
}

export function PhoneFrame({ width, children }: FrameProps) {
  return (
    <Box
      sx={{
        position: 'relative',
        width: width + 32,
        border: '12px solid #333',
        borderRadius: '36px',
        overflow: 'hidden',
        boxShadow: '0 8px 32px rgba(0,0,0,0.25)',
        backgroundColor: '#fff',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: '50%',
          transform: 'translateX(-50%)',
          width: 80,
          height: 20,
          backgroundColor: '#333',
          borderBottomLeftRadius: 12,
          borderBottomRightRadius: 12,
          zIndex: 10,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 1.5,
        }}
      >
        <Box sx={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: '#555' }} />
        <Box sx={{ width: 18, height: 4, borderRadius: 2, backgroundColor: '#555' }} />
      </Box>
      <Box sx={{ pt: 2.5, height: 580, overflow: 'auto' }}>
        {children}
      </Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          py: 1.5,
          backgroundColor: '#333',
        }}
      >
        <Box
          sx={{
            width: 32,
            height: 32,
            borderRadius: '50%',
            border: '2px solid #555',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Box sx={{ width: 14, height: 14, border: '2px solid #555', borderRadius: 1 }} />
        </Box>
      </Box>
    </Box>
  );
}

export function TabletFrame({ width, children }: FrameProps) {
  return (
    <Box
      sx={{
        position: 'relative',
        width: width + 40,
        border: '16px solid #333',
        borderRadius: '24px',
        overflow: 'hidden',
        boxShadow: '0 8px 32px rgba(0,0,0,0.20)',
        backgroundColor: '#fff',
      }}
    >
      <Box sx={{ height: 520, overflow: 'auto' }}>
        {children}
      </Box>
    </Box>
  );
}
